import { Outlet, useParams } from "react-router-dom";
import { AppRouteProps } from "../../components/router/AppRoute";
import { wrapRoutes } from "../../components/router/AuthWrapper";
import List from "./patient-list/pages/list";
import CarePlans from "./care-plans/pages/list";
import Examination from "./examination/pages/index";
import PatientProcess from "./patient-process/pages/index";
import PatientTable from "./patient-table";
import CreateTab, { registerWrapperComponent } from "../../hooks/useTab";
import React from "react";
import { useTranslate } from "src/locales";

// Wrapper component'leri başlangıçta register et
registerWrapperComponent("nurse/patient-list", () => React.createElement(List));
registerWrapperComponent("nurse/care-plans", () => React.createElement(CarePlans));
registerWrapperComponent("nurse/examination", () => React.createElement(Examination));
registerWrapperComponent("nurse/patient-process", () => React.createElement(PatientProcess));
registerWrapperComponent("nurse/patient-table", () => React.createElement(PatientTable));

export const nurseRoutes: AppRouteProps[] = [
  {
    path: "nurse",
    element: (
      <NurseLayout>
        <Outlet />
      </NurseLayout>
    ),
    children: wrapRoutes([
      { path: "patient-list", element: <PatientListWrapper title="Hemşire İşlemleri" />, role: "frmNurseProcessNew" },
      { path: "care-plans", element: <CarePlansWrapper title="Bakım Planı Tanımlama" />, role: "frmCarePlan" },
      { path: "examination/:id?", element: <ExaminationWrapper title="Tetkik Hazırlık" />, role: "frmNurseExamination" },
      { path: "patient-process/:id", element: <PatientProcessWrapper title="İşlemler" />, role: "frmNurseProcessNew" },
      { path: "patient-table/:id?", element: <PatientTableWrapper title={"Hasta Tabelası"} />, role: "frmNurseProcessNew" },
    ]),
  },
];

function NurseLayout(props: any) {
  return <>{props.children}</>;
}

function PatientListWrapper({ title }: { title: string }) {
  return <CreateTab title={title} element={<List />} path="nurse/patient-list" />;
}

function CarePlansWrapper({ title }: { title: string }) {
  return <CreateTab title={title} element={<CarePlans />} path="nurse/care-plans" />;
}

function ExaminationWrapper({ title }: { title: string }) {
  const { id } = useParams();
  const { t } = useTranslate();
  const patientId = id ? parseInt(id) : null;

  return <CreateTab title={t(title)} element={<Examination patientId={patientId} />} patientId={patientId} path="nurse/examination" />;
}

function PatientProcessWrapper({ title }: { title: string }) {
  const { id } = useParams();
  const { t } = useTranslate();
  const patientId = id ? parseInt(id) : null;

  return <CreateTab title={t(title)} element={<PatientProcess ptId={patientId?.toString()} />} patientId={patientId} path="nurse/patient-process" />;
}

function PatientTableWrapper({ title }: { title: string }) {
  const { id } = useParams();
  const { t } = useTranslate();
  const patientId = id ? parseInt(id) : null;

  return (
    <CreateTab
      title={t(title)}
      element={<PatientTable patientId={patientId} />}
      patientId={patientId}
      path={patientId ? `nurse/patient-table/${patientId}` : "nurse/patient-table"}
    />
  );
}
